export default __webpack_public_path__ + "static/media/broom.110242f5.svg";